import type { HeroProps } from '@/components/imprint/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['de-DE'].seo,
    title: 'Impressum | Lemonade',
    metaTitle: 'Impressum | Lemonade',
  },
  hero: {
    title: `Ein paar Dinge, die unsere Anwälte für wichtig halten...\n(oder, falls du dies bevorzugst, haben wir auch eine <a target="_blank" rel="noopener" href="/impressum.pdf" download>PDF</a>`,
  },
};
